export default __webpack_public_path__ + "static/media/externalCollections.aa9781ff.svg";